import assetPath from '/app/packages/lebenslauf/articles/src/assets/schlusssatz-bewerbung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')